import { createContext, useContext, type ReactElement } from 'react';
import {
  AuthState,
  type AuthStateAnonymous,
  type AuthStateAuthenticated,
  type AuthStateError,
  type AuthStateLoading,
  type UseCustomerResponse,
} from '../../../customer/use-customer';

export const CustomerContext = createContext<UseCustomerResponse>({
  authState: AuthState.isLoading,
  customerData: undefined,
});

interface AuthGuardProps {
  authenticated?: (state: AuthStateAuthenticated) => ReactElement;
  anonymous?: (state: AuthStateAnonymous) => ReactElement;
  loading?: (state: AuthStateLoading) => ReactElement;
  error?: (state: AuthStateError) => ReactElement;
}

export function AuthGuard(props: AuthGuardProps) {
  const { authenticated, anonymous, loading, error } = props;
  const auth = useContext(CustomerContext);

  if (authenticated && auth.authState === AuthState.isAuthenticated) {
    return authenticated(auth);
  }
  if (anonymous && auth.authState === AuthState.isAnonymous) {
    return anonymous(auth);
  }
  if (loading && auth.authState === AuthState.isLoading) {
    return loading(auth);
  }
  if (error && auth.authState === AuthState.isError) {
    return error(auth);
  }
  return null;
}
